import { Component } from '@angular/core';
import { smoothlyMenu } from '../../../app.helpers';
declare var jQuery:any;

@Component({
  selector: 'topnavbar',
  template: require('./topnavbar.template.html')
})
export class TopNavbarComponent {

  toggleNavigation(): void {
    jQuery("body").toggleClass("mini-navbar");
    smoothlyMenu();
  }

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/components/common/navigation/topnavbar.component.ts